import * as api from "@/api/williams/contractors";
import { useQuery } from "react-query";
import { queryKeys } from "../../queryKeys";
import { ContractorFilters } from "@/api/williams/contractors";

export const DEFAULT_CONTRACTOR_FILTERS = { skip: 0, take: 1000 };

export function useContractorLookup(filters: Partial<ContractorFilters> = {}) {
  const queryFilters = { ...DEFAULT_CONTRACTOR_FILTERS, ...filters };

  return useQuery(queryKeys.contractor.filter(queryFilters), () => {
    return api.getContractors(queryFilters);
  });
}
